// extracted by mini-css-extract-plugin
module.exports = {"home":"styles_home__1vS_M","content":"styles_content__2Jh-a","infoBox":"styles_infoBox__AX0k9","number":"styles_number__zsSJh","title":"styles_title__36WW0"};